package com.ilussobsa.sdk

import com.lightningkite.kiteui.Log
import com.lightningkite.now
import kotlinx.datetime.Instant


class MergedLog(vararg val outputs: Log): Log {
    override fun tag(tag: String): Log = MergedLog(*(outputs.map {it.tag(tag)}.toTypedArray()))
    override fun log(vararg entries: Any?) = outputs.forEach { it.log(*entries) }
    override fun error(vararg entries: Any?) = outputs.forEach { it.error(*entries) }
    override fun info(vararg entries: Any?) = outputs.forEach { it.info(*entries) }
    override fun warn(vararg entries: Any?) = outputs.forEach { it.warn(*entries) }

}

val consoleAndRecorded = MergedLog(StoredLog.main, Log)

class StoredLog(): Log {
    companion object {
        val main = StoredLog()
    }
    val storedMessages = ArrayList<Pair<Instant, String>>()
    override fun log(vararg entries: Any?) {
        entries.forEach {
            storedMessages += now() to it.toString()
        }
        while(storedMessages.size > 10000) { storedMessages.removeFirstOrNull() ?: break }
    }
    override fun tag(tag: String): Log = PrefixLog(tag, this)
    override fun error(vararg entries: Any?) = log(*entries)
    override fun info(vararg entries: Any?) = log(*entries)
    override fun warn(vararg entries: Any?) = log(*entries)
}

class PrefixLog(val prefix: String, val wraps: Log): Log {
    override fun tag(tag: String): Log = PrefixLog("$prefix-$tag", wraps)
    override fun log(vararg entries: Any?) = wraps.log(prefix, *entries)
    override fun error(vararg entries: Any?) = wraps.error(prefix, *entries)
    override fun info(vararg entries: Any?) = wraps.info(prefix, *entries)
    override fun warn(vararg entries: Any?) = wraps.warn(prefix, *entries)
}